module.exports = __webpack_public_path__ + "img/49.3d77533d.jpg";